import { Box, Typography } from '@mui/material';
import { useHighlightStyles } from './highlight.styles';

const Highlight = ({ number, highlightText }) => {
  const classes = useHighlightStyles();

  return (
    <Box
      display='flex'
      justifyContent='space-between'
      alignItems='center'
      width='max-content'
      minWidth='max-content'
    >
      <Typography variant='h1' className={classes.numbers}>
        {number}
      </Typography>
      <Typography className={classes.text}>
        +<br />
        {highlightText}
      </Typography>
    </Box>
  );
};
export default Highlight;
